import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'


import axios from 'axios';

import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)


import { LMap, LTileLayer, LMarker,LPolyline } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);

Vue.component('l-polyline', LPolyline);



import LControlFullscreen from 'vue2-leaflet-fullscreen';
Vue.component('l-control-fullscreen', LControlFullscreen);


import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx);


import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);
// eslint-disable-next-line vue/multi-word-component-names
Vue.component('apexchart', VueApexCharts);


import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent);


import VueMapbox from "vue-mapbox";
import Mapbox from "mapbox-gl";

Vue.use(VueMapbox, { mapboxgl: Mapbox });

// api servidor local
//axios.defaults.baseURL='http://localhost:3000/api/'

// api servidor disatel
//axios.defaults.baseURL='http://191.98.228.86:3400/api/'

// api servidor sin https 
//axios.defaults.baseURL='http://68.183.147.124:3000/api/'

// api servidor productivo https 
axios.defaults.baseURL='https://passenger-qr.com/api/'




Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
